import type { ReactNode } from 'react'
import { Trans, useTranslation } from 'react-i18next'

// ENG-216 — blocked on BS-201 (Artur and Agata are finalising the Terms). Fill
// in the URL and the link renders itself; that is the whole change. Privacy
// Policy is reserved for the same treatment: set the URL, then extend the
// login.legal sentence with a <privacy> tag and add it to the component map.
const LEGAL: { termsUrl: string | null; privacyUrl: string | null } = {
  termsUrl: null,
  privacyUrl: null,
}

// A null URL renders plain text rather than a dead anchor: href="#" is
// focusable, announced as a link, and re-navigates the route — which would wipe
// a half-typed password on the sign-in page.
function LegalLink({ href, children }: { href?: string | null; children?: ReactNode }) {
  if (!href) return <span>{children}</span>
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="font-medium text-primary hover:underline">
      {children}
    </a>
  )
}

export default function AuthLegalLine() {
  const { t } = useTranslation('admin')
  return (
    <p className="text-xs leading-relaxed text-muted-foreground">
      <Trans t={t} i18nKey="login.legal" components={{ terms: <LegalLink href={LEGAL.termsUrl} /> }} />
    </p>
  )
}
